<span class="actions" [class.actions--expanded]="showDeleteConfirmation">
  @if (showDeleteConfirmation) {
    <span class="confirmation" @expand>
      Est-vous sûr(e)&nbsp;?
      <button class="cta cta__choice" (click)="showDeleteConfirmation = false" type="button">Annuler</button>
      <span class="divider" aria-hidden="true"></span>
      <button class="cta cta__choice cta__choice--delete" (click)="fileCancelled.emit()" type="button">
        Supprimer
      </button>
    </span>
  }

  @if (isDownloadable) {
    <button
      class="cta cta--download-button"
      (click)="downloadUploadedFile()"
      type="button"
      mat-icon-button
      color="primary"
      title="Télécharger le fichier"
      aria-label="Télécharger le fichier"
    >
      <span class="icon-wrapper">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
          <path
            fill="currentcolor"
            d="M5.33555 6.0506C5.3343 6.0339 5.33366 6.01702 5.33366 6V0.666667C5.33366 0.298667 5.63166 0 6.00033 0C6.36899 0 6.66699 0.298667 6.66699 0.666667V5.99988L8.26699 4.8C8.56166 4.578 8.97966 4.63867 9.20033 4.93333C9.42166 5.228 9.36166 5.646 9.06699 5.86667L6.40033 7.86667C6.28233 7.95533 6.14099 8 6.00033 8C5.86633 8 5.73233 7.95933 5.61699 7.87867L2.95033 6.00267C2.64899 5.79067 2.57633 5.37467 2.78833 5.074C3.00033 4.77267 3.41566 4.7 3.71699 4.912L5.33555 6.0506ZM2.00033 9.33333V10H10.0003V9.33333C10.0003 8.96667 10.3003 8.66667 10.667 8.66667C11.0337 8.66667 11.3337 8.96667 11.3337 9.33333V10.6667C11.3337 11.0333 11.0337 11.3333 10.667 11.3333H1.33366C0.966992 11.3333 0.666992 11.0333 0.666992 10.6667V9.33333C0.666992 8.96667 0.966992 8.66667 1.33366 8.66667C1.70033 8.66667 2.00033 8.96667 2.00033 9.33333Z"
          />
        </svg>
      </span>
    </button>
  }

  <button
    class="cta cta--delete-button"
    [disabled]="showDeleteConfirmation"
    (click)="showDeleteConfirmation = true"
    type="button"
    mat-icon-button
    color="primary"
    title="Supprimer le fichier"
  >
    <span class="icon-wrapper">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 13">
        <path
          fill="currentcolor"
          d="M9.5557 10.2772C9.5557 10.6037 9.29022 10.8698 8.96311 10.8698H3.03718C2.71007 10.8698 2.44459 10.6037 2.44459 10.2772V3.75868H9.5557V10.2772ZM4.81496 1.58268C4.81496 1.49083 4.94177 1.38831 5.11126 1.38831H6.88903C7.05852 1.38831 7.18533 1.49083 7.18533 1.58268V2.5735H4.81496V1.58268ZM11.3335 2.5735H10.7409H8.37051V1.58268C8.37051 0.821792 7.70622 0.203125 6.88903 0.203125H5.11126C4.29407 0.203125 3.62977 0.821792 3.62977 1.58268V2.5735H1.2594H0.666811C0.340885 2.5735 0.0742188 2.84016 0.0742188 3.16609C0.0742188 3.49201 0.340885 3.75868 0.666811 3.75868H1.2594V10.2772C1.2594 11.2573 2.05703 12.055 3.03718 12.055H8.96311C9.94326 12.055 10.7409 11.2573 10.7409 10.2772V3.75868H11.3335C11.6594 3.75868 11.9261 3.49201 11.9261 3.16609C11.9261 2.84016 11.6594 2.5735 11.3335 2.5735Z"
        />
      </svg>
    </span>
  </button>
</span>
